import { createGlobalStyle } from "styled-components";
import itcAvantGardeBoldWoff2Font from "@/assets/fonts/itc_avant_garde_gothic_bold-webfont.woff2";
import itcAvantGardeBoldWoffFont from "@/assets/fonts/itc_avant_garde_gothic_bold-webfont.woff";
import itcAvantGardeMediumWoff2Font from "@/assets/fonts/itc_avant_garde_gothic_medium-webfont.woff2";
import itcAvantGardeMediumWoffFont from "@/assets/fonts/itc_avant_garde_gothic_medium-webfont.woff";
import Maitree400 from "@/assets/fonts/maitree-regular-webfont.woff2";
import Maitree700 from "@/assets/fonts/maitree-bold-webfont.woff2";
// import "@fontsource/maitree/400.css";
// import "@fontsource/maitree/700.css";
import { fluid } from "./utils/fluid";

export const GlobalStyle = createGlobalStyle`
/*
  Josh's Custom CSS Reset
  https://www.joshwcomeau.com/css/custom-css-reset/
*/

*, *::before, *::after {
  box-sizing: border-box;
}

* {
  margin: 0;
}

html, body {
    height: 100%;
  }

body {
  line-height: 1.5;
  -webkit-font-smoothing: antialiased;
}

img, picture, video, canvas, svg {
  display: block;
  max-width: 100%;
}

input, button, textarea, select {
  font: inherit;
}

p, h1, h2, h3, h4, h5, h6 {
  overflow-wrap: break-word;
}

#root, #__next {
  isolation: isolate;
}

/* 
  Custom Fonts 
*/
@font-face {
  font-family: 'itc_avant_garde_gothicbold';
  src: url(${itcAvantGardeBoldWoff2Font}) format('woff2'),
    url(${itcAvantGardeBoldWoffFont}) format('woff');
  /* font-weight: 700; */
  font-style: normal;
}

@font-face {
  font-family: 'itc_avant_garde_gothicmedium';
  src: url(${itcAvantGardeMediumWoff2Font}) format('woff2'),
    url(${itcAvantGardeMediumWoffFont}) format('woff');
  /* font-weight: 500; */
  font-style: normal;
}

@font-face {
  font-family: 'Maitree';
  font-style: normal;
  font-weight: 400;
  src: url(${Maitree400}) format('woff2');
  font-display: swap;
}

@font-face {
  font-family: 'Maitree';
  font-style: normal;
  font-weight: 700;
  src: url(${Maitree700}) format('woff2');
  font-display: swap;
}

/* 
  Stanley Yeo Custom Styles 
*/
html {
  scroll-behavior: smooth;
  font-size: 100%;
}

body{
  font-family: ${({ theme }) => theme.fontFace.maitree};
  color: ${({ theme }) => theme.colors.onyx};
  background: ${({ theme }) => theme.colors.white};
}

p,
ol,
ul {
  letter-spacing: ${({ theme }) => theme.letterSpacing.body};
  font-size: ${({ theme }) =>
    fluid({
      minSize: theme.fontScale.majorSecond.size,
      maxSize: theme.fontScale.augmentedFourth.size,
      minVW: theme.breakpointValues.xs,
      maxVW: theme.breakpointValues.xl,
      baseFontMin: theme.baseFont.xs,
      baseFontMax: theme.baseFont.xl,
    })};
  &:last-child {
    margin-bottom: 0;
  }
  /* xs only */
  @media ${({ theme }) => theme.breakpoints.xs} {
    line-height: ${({ theme }) => theme.lineHeight.body.xs};
  }
  /* sm and up */
  @media ${({ theme }) => theme.breakpoints.sm} {
    line-height: ${({ theme }) => theme.lineHeight.body.sm};
  }
  /* sm to md */
  @media ${({ theme }) => theme.breakpoints.md} {
    line-height: ${({ theme }) => theme.lineHeight.body.md};
  }
  /* md and up */
  @media ${({ theme }) => theme.breakpoints.lg} {
    line-height: ${({ theme }) => theme.lineHeight.body.lg};
  }
  /* lg to xl */
  @media ${({ theme }) => theme.breakpoints.xl} {
    line-height: ${({ theme }) => theme.lineHeight.body.xl};
  }
}

p {
  margin-bottom: ${({ theme }) => `
    calc(${fluid({
      minSize: theme.fontScale.majorSecond.size,
      maxSize: theme.fontScale.augmentedFourth.size,
      minVW: theme.breakpointValues.xs,
      maxVW: theme.breakpointValues.xl,
      baseFontMin: theme.baseFont.xs,
      baseFontMax: theme.baseFont.xl,
    })} * 2)
  `};
}
  
button {
  cursor: pointer;
}

a {
  text-decoration: none;
}

ol,
ul {
    li {
      margin-bottom: ${({ theme }) => `
        calc(${fluid({
          minSize: theme.fontScale.majorSecond.size,
          maxSize: theme.fontScale.augmentedFourth.size,
          minVW: theme.breakpointValues.xs,
          maxVW: theme.breakpointValues.xl,
          baseFontMin: theme.baseFont.xs,
          baseFontMax: theme.baseFont.xl,
        })} / 2)
      `};
    }
  }
`;
